module.exports = __webpack_public_path__ + "img/picnic-woman.efdcc59.svg";